<template>
	<v-popover
		class="xs-5 flex xs-right"
		placement="bottom-end"
		popoverClass="xs-12 r2"
		popoverArrowClass="xs-0"
		popoverInnerClass="xs-12 r2 bg5 b1 bc7"
	>
		<crm-icon color="c1" name="kebab" size="normal" />
		<!-- context menu -->
		<div class="xs-12 cu2" slot="popover">
			<div
				@click="$emit('lesson:edit')"
				class="flex xs-12 p1 bc7 bb1 menu-item"
				v-close-popover
			>
				{{ $t("edit_lesson") }}
			</div>
			<div
				@click="$emit('lesson:delete')"
				class="flex xs-12 p1 cError menu-item"
				v-close-popover
			>
				{{ $t("delete_lesson") }}
			</div>
		</div>
	</v-popover>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"

export default {
	components: {
		CrmIcon
	}
}
</script>

<style scoped>
.menu-item:hover {
	background-color: rgb(248, 248, 249);
}
</style>
